import Modal from "@/packages/vmodal/Modal";
import ModalWrapper from "@/packages/vmodal/ModalWrapper.vue";
import {reactive} from "vue";

export default {
	install(Vue, defaultOptions) {
		Vue.component("Modal", ModalWrapper);
		Vue.prototype.$vmodal = reactive(new Modal(defaultOptions));
	},
};
